module.exports = __webpack_public_path__ + "img/close.b65f2dea.png";